<template>
	<div class="default-wrapper">
		<div class="header-wrapper">
			<d-container fluid class="p-0">
				<d-row no-gutters>
					<d-col style="max-width:190px;">
						<d-input v-model="searchString" class="mb-2" size="sm" type="text" placeholder="Wyszukaj artystę..." />
					</d-col>
					<d-col class="ml-5 mr-5">
						<d-button-group size="small" v-show="searchString == ''">
							<d-button v-for="(letter, i) in filterLetters" :key="i" :theme="letter == activeLetter ? 'primary' : 'light'" @click="activeLetter = letter">{{letter}}</d-button>
						</d-button-group>
					</d-col>
				</d-row>
			</d-container>
		</div>
		<loader v-if="loading" />
		<div v-else class="cards-wrapper">
			<d-card
				style="max-width:200px; margin:0 1rem 1rem 0; flex: 1 0 auto;"
				v-for="(artist, i) in filteredArtists" :key="i"
				@click='() => clickArtist(artist)'
			>
				<d-card-img :src="artist.image_url" style="width:200px;height:200px;border-radius:8px 8px 0 0;"/>
				<d-card-body>
					<p>{{ artist.name }}</p>
				</d-card-body>
			</d-card>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: true,
				activeLetter: 'A',
				searchString: '',
			}
		},
		computed: {
			filterLetters() {
				try {
					return Array.from(new Set(this.$store.state.artists.all.map(a => a.name[0].toUpperCase()).sort()));
				} catch {
					return []
				}
			},
			filteredArtists() {
				try {
					return this.searchString === '' ?
						this.$store.state.artists.all.filter(a => a.name[0].toUpperCase() == this.activeLetter) :
						this.$store.state.artists.all.filter(a => a.name.toUpperCase().indexOf(this.searchString.toUpperCase()) > -1)
				} catch {
					return []
				}
			},
		},
		methods: {
			clickArtist(artist) {
				this.$router.push(`/artist/${artist.id}`);
			}
		},
		async created() {
			this.activeLetter = this.filterLetters[0];
			this.loading = false;
		},
	}
</script>

<style scoped lang="less">
	.cards-wrapper {
		display:flex;
		flex-wrap:wrap;
		cursor: pointer;
	}
</style>